var d3 = require('d3')
var moment = require('moment')
var graph = {}
var xAxisGraphics = null
var yAxisGraphics = null
var controlButtons = null

d3.scaleLogisticLinearLog = function()
{
	var domain = [0, 2];
	var range = [0, 2];
	var transition = 1;
	var steepness = 20;
	
	
	var unitStep = function(input)
	{
		return 1 / (1 + Math.exp(-steepness * (Math.abs(transition) / transition * (input - transition))));
	}
	
	var log = function(input)
	{
		return (range[1] - range[0]) / Math.log(2 * domain[1] / transition) * Math.log(2 * input / transition + Number.MIN_VALUE) + range[0];
	}
	
	var linear = function(input)
	{
		return (log(transition) - range[0]) / transition * input + range[0];
	}
	
	var output = function(input)
	{
		var unitStepValue = unitStep(input);
		
		return unitStepValue * (log(input)) + (1 - unitStepValue) * (linear(input));
	}
	
	
	var scale = function(input)
	{
		return output(input);
	}
	
	
	scale.copy = function()
	{
		var scaleCopy = d3.scaleLogisticLinearLog();
		
		scaleCopy.domain(domain);
		scaleCopy.range(range);
		scaleCopy.steepness(steepness);
		
		return scaleCopy;
	}
	
	
	scale.domain = function(newDomain)
	{
		if (arguments.length === 0)
		{
			return domain;
		}
		
		domain[1] = newDomain[1];
	}
	
	scale.range = function(newRange)
	{
		if (arguments.length === 0)
		{
			return range;
		}
		
		range = newRange;
	}
	
	
	scale.steepness = function(newSteepness)
	{
		if (arguments.length === 0)
		{
			return steepness;
		}
		
		steepness = newSteepness;
	}
	
	
	return scale;
}


graph.initializeChart = function(responses, goals, start, end)
{
	var progressChart = document.getElementById("progress-chart"); //check if the chart exists
	if (progressChart == null)
		return;

	//set some constants
	graph.aspectRatio = 16/7;
	graph.separation = 10;
	graph.pointSize = 2.5;
	graph.margin = {top: 50, right: 50, bottom: 200, left: 75};

	graph.daysPerGraph = 42;
	graph.daysPerGroup = graph.daysPerGraph / 2;
	graph.millisecondsPerDay = 1000 * 60 * 60 * 24;

	graph.animate = false; //do not animate during initialization (mostly due to print graph setup)

	var startDate = new Date(start + "T12:00:00Z");//new Date(progressChart.getAttribute("data-start") + "T12:00:00Z");
	var endDate = new Date(end + "T12:00:00Z");//new Date(progressChart.getAttribute("data-end") + "T12:00:00Z");

	var chartData = responses;//JSON.parse(progressChart.getAttribute("data-responses"));
	var goalData = goals;//JSON.parse(progressChart.getAttribute("data-goals"));

	var showGoals = (progressChart.getAttribute("data-show-goals") === "true");

	graph.startTime = startDate.getTime();
	graph.currentStartDate = new Date(startDate.getTime());
	graph.endTime = endDate.getTime();


	var endDateIndex = (endDate.getTime() - startDate.getTime()) / graph.millisecondsPerDay;

	if (endDateIndex > (graph.daysPerGraph - 1))
	{
		var endDateGroup = Math.floor(endDateIndex / graph.daysPerGroup);

		graph.currentStartDate.setTime(graph.currentStartDate.getTime() + (endDateGroup - 1) * graph.daysPerGroup * graph.millisecondsPerDay);
	}

	graph.currentStartTime = graph.currentStartDate.getTime();

	endDate = new Date(graph.currentStartTime + ((graph.daysPerGraph - 1) * graph.millisecondsPerDay));
	graph.currentEndDate = new Date(endDate.getTime());
	graph.currentEndTime = graph.currentEndDate.getTime();


	graph.xScale = d3.scaleTime();

	graph.xAxis = d3.axisBottom(graph.xScale);
	graph.xAxis.tickFormat(d3.timeFormat("%b %d"));

	var svgContainer = d3.select("#progress-chart");
	var svg = svgContainer.append("svg");

	var container = svg.append("g");
	container.attr("transform", "translate(" + String(graph.margin.left) + ", " + String(graph.margin.top) + ")");

	var chart = container.append("g");
	chart.attr("id", "chart");


	var xAxisGraphics = chart.append("g");
	xAxisGraphics.attr("class", "x axis");


	var yDomain = [0, 200];

	var maximum = d3.max
	(
		chartData,
		function(object)
		{
			return object["responses"];
		}
	);

	graph.yScale = d3.scaleLogisticLinearLog();
	graph.yScale.domain(yDomain);

	graph.yAxis = d3.axisLeft(graph.yScale);

	var yAxisGraphics = chart.append("g");
	yAxisGraphics.attr("class", "y axis");
	yAxisGraphics.attr("transform", "translate(-" + String(graph.separation) + ", 0)");


	var unscaledLine = d3.line();
	unscaledLine.x
	(
		function(data)
		{
			return data["x"];
		}
	);
	unscaledLine.y
	(
		function(data)
		{
			return data["y"];
		}
	);

	var xMirroredUnscaledLine = d3.line();
	xMirroredUnscaledLine.x
	(
		function(data)
		{
			return -1 * unscaledLine.x()(data);
		}
	);
	xMirroredUnscaledLine.y(unscaledLine.y());

	var roundedUnscaledLine = d3.line();
	roundedUnscaledLine.x
	(
		function(data)
		{
			return Math.round(unscaledLine.x()(data));
		}
	);
	roundedUnscaledLine.y
	(
		function(data)
		{
			return Math.round(unscaledLine.y()(data));
		}
	);

	graph.dateLine = d3.line();
	graph.dateLine.x
	(
		function(data)
		{
			return graph.xScale(data["date"]);
		}
	);
	graph.dateLine.y
	(
		function(data)
		{
			return graph.yScale(data["y"]);
		}
	);

	var roundedDateLine = d3.line();
	roundedDateLine.x
	(
		function(data)
		{
			return Math.round(graph.dateLine.x()(data));
		}
	);
	roundedDateLine.y
	(
		function(data)
		{
			return Math.round(graph.dateLine.y()(data));
		}
	);

	graph.responsesLine = d3.line();
	graph.responsesLine.x(graph.dateLine.x());
	graph.responsesLine.y
	(
		function(data)
		{
			return graph.yScale(data["responses"]);
		}
	);

	graph.errorsLine = d3.line();
	graph.errorsLine.x(graph.dateLine.x());
	graph.errorsLine.y
	(
		function(data)
		{
			return graph.yScale(data["errors"]);
		}
	);


	var goalTimes = [];
	var count = goalData.length;
	for (var index = 0; index < count; index++)
	{
		var goalDate = new Date(goalData[index]["date"] + "T12:00:00Z");
		goalTimes.push(goalDate.getTime());

		var goalDatum =
		[
			{"date": goalDate, "y": yDomain[0]},
			{"date": goalDate, "y": yDomain[1]}
		];

		var goalLine = chart.append("path");
		goalLine.datum(goalDatum);
		goalLine.attr("class", "goal line");
		goalLine.attr("d", graph.dateLine);
	}



	var responses = chart.append("g");
	var errors = chart.append("g");

	var count = chartData.length;
	if (count !== 0)
	{
		chartData[0]["date"] = new Date(chartData[0]["date"] + "T12:00:00Z");
	}

	var div = d3.select("body").append("div")	
    .attr("class", "graph-point-data")				
    .style("opacity", 0);

	for (var index = 0; index < count; index++)
	{
		var responsesCircle = responses.append("circle");
		responsesCircle.datum(chartData[index]);
		responsesCircle.attr("class", "response point");
		responsesCircle.attr("r", 0);
		responsesCircle.attr("cx", 0);
		responsesCircle.attr("cy", 0);

		responses.append("circle")
		.datum(chartData[index])
		.attr("class", "response point clicker")
		.attr("r", 10)
		.style("cursor", "pointer")
		.attr("opacity", 0)
		.on("mouseover", function(d) {
			div.transition()	
				.duration(200)
				.style("opacity", .9);
				
			div.html(`
				${moment(d.date).format("MMM D")}
				<br/> Exercise ${d.probeNumber}
				<br/> ${d.responses} wpm
				`)
				.style("left", (d3.event.pageX) + "px")		
				.style("top", (d3.event.pageY - 28) + "px")
			})					
		.on("mouseout", function(d) {
            div.transition()		
                .duration(500)		
                .style("opacity", 0);	
        });

		var errorsCircle = errors.append("circle");
		errorsCircle.datum(chartData[index]);
		errorsCircle.attr("class", "error point");
		errorsCircle.attr("r", 0);
		errorsCircle.attr("cx", 0);
		errorsCircle.attr("cy", 0);

		responses.append("circle")
		.datum(chartData[index])
		.attr("class", "error point clicker")
		.attr("r", 10)
		.style("cursor", "pointer")
		.attr("opacity", 0)
		.on("mouseover", function(d) {
			div.transition()	
				.duration(200)
				.style("opacity", .9);
				div.html(`
				${moment(d.date).format("MMM D")}
				<br/> Exercise ${d.probeNumber}
				<br/> ${d.errors} errors
				`)
				.style("left", (d3.event.pageX) + "px")		
				.style("top", (d3.event.pageY - 28) + "px")
			})					
		.on("mouseout", function(d) {
            div.transition()		
                .duration(500)		
                .style("opacity", 0);	
        });


		if (index !== (count - 1))
		{
			var currentDate = chartData[index]["date"];
			var currentTime = currentDate.getTime();

			var nextDate = new Date(chartData[index + 1]["date"] + "T12:00:00Z");
			chartData[index + 1]["date"] = nextDate;

			if ((nextDate.getTime() - currentTime) === graph.millisecondsPerDay //if days are consecutive
					&& goalTimes.indexOf(currentTime) === -1 //if it's not a goal
					&& chartData[index].probeNumber === chartData[index + 1].probeNumber) //if same probe
			{
				var responsesPath = responses.append("path");
				responsesPath.datum([chartData[index], chartData[index + 1]]);
				responsesPath.attr("class", "response line");
				responsesPath.attr("d", graph.responsesLine);

				var errorsPath = errors.append("path");
				errorsPath.datum([chartData[index], chartData[index + 1]]);
				errorsPath.attr("class", "error line");
				errorsPath.attr("d", graph.errorsLine);
			}
		}
	}

	graph.drawReferenceLines(chart, graph.currentStartDate, graph.currentEndDate);

	svg.append("clipPath")
    .attr("id", "chart-area")
    .append("rect")
    .attr("x", 0)
    .attr("y", 0)

	var currentSunday = new Date(endDate.getTime());
	while (currentSunday.getTime() >= graph.startTime)
	{
		var currentSundayCopy = new Date(currentSunday.getTime());
		var sundayDatum =
		[
			{"date": currentSundayCopy, "y": yDomain[0]},
			{"date": currentSundayCopy, "y": yDomain[1]}
		];

		var sundayPath = chart.append("path");
		sundayPath.datum(sundayDatum);
		sundayPath.attr("d", roundedDateLine);
		sundayPath.attr("class", "sunday line dashed");

		if (moment(currentSunday).isSame(new Date(),'week')) {
			chart.append("rect")
			.datum([{ date: moment().day(-1).hour(8).minute(0).second(0).toDate() }, { date: new Date(currentSunday.getTime()) }])
			.attr('class', 'current-week-rect')
			.attr('y', 0)
			.attr('opacity', 0.08)
			.attr('fill', 'black')
			.attr('pointer-events', 'none')
			.attr("clip-path", "url(#chart-area)");
		}

		currentSunday.setTime(currentSunday.getTime() - 7 * graph.millisecondsPerDay);
	}

	var controlButtons = container.append("g");
	controlButtons.attr("id", "control-buttons");


	graph.arrowHeight = 20;
	var arrowTailWidth = 2 * graph.arrowHeight;
	var arrowHeadWidth = 1/3 * arrowTailWidth;

	graph.rectangleWidth = 1.75 * arrowTailWidth;
	var rectangleHeight = 1.75 * graph.arrowHeight;

	var arrowHeadPoints =
	[
		{"x": arrowHeadWidth,	"y": -graph.arrowHeight / 2},
		{"x": 0,				"y": 0},
		{"x": arrowHeadWidth,	"y": graph.arrowHeight / 2}
	];

	var arrowTailPoints =
	[
		{"x": 0,				"y": 0},
		{"x": arrowTailWidth,	"y": 0},
	];

	var leftArrow = controlButtons.append("g");
	leftArrow.attr("id", "left-arrow");
	leftArrow.attr("class", "control-button");

	var leftArrowRectangle = leftArrow.append("rect");
	leftArrowRectangle.attr("class", "rectangle");
	leftArrowRectangle.attr("rx", 3);
	leftArrowRectangle.attr("ry", 3);
	leftArrowRectangle.attr("x", 0);
	leftArrowRectangle.attr("y", 0);
	leftArrowRectangle.attr("width", graph.rectangleWidth);
	leftArrowRectangle.attr("height", rectangleHeight);

	var leftArrowArrow = leftArrow.append("g");
	leftArrowArrow.attr("transform", "translate(" + (graph.rectangleWidth / 2 - arrowTailWidth / 2) + ", " + (rectangleHeight / 2) +")");

	var leftArrowArrowHead = leftArrowArrow.append("path");
	leftArrowArrowHead.datum(arrowHeadPoints);
	leftArrowArrowHead.attr("d", unscaledLine);
	leftArrowArrowHead.attr("class", "line");

	var leftArrowArrowTail = leftArrowArrow.append("path");
	leftArrowArrowTail.datum(arrowTailPoints);
	leftArrowArrowTail.attr("d", unscaledLine);
	leftArrowArrowTail.attr("class", "line");


	var rightArrow = leftArrow.node().cloneNode(true);
	rightArrow.id = "right-arrow";
	rightArrow.setAttribute("transform", "scale(-1, 1)");

	controlButtons.node().appendChild(rightArrow);



	var legend = container.append("g");
	legend.attr("id", "legend");

	var legendIconSize = 25;

	var responsesLegendPoint = legend.append("circle");
	responsesLegendPoint.attr("cx", legendIconSize / 2);
	responsesLegendPoint.attr("cy", responsesLegendPoint.attr("cx"));
	responsesLegendPoint.attr("r", graph.pointSize);
	responsesLegendPoint.attr("class", "response point legend");

	var responsesLegendLineY = parseFloat(responsesLegendPoint.attr("cy"));
	var responsesLegendLineData =
	[
		{"x": 0,				"y": responsesLegendLineY},
		{"x": legendIconSize,	"y": responsesLegendLineY}
	];

	var responsesLegendLine = legend.append("path");
	responsesLegendLine.datum(responsesLegendLineData);
	responsesLegendLine.attr("d", unscaledLine);
	responsesLegendLine.attr("class", "response line legend");

	var responsesLegendLabel = legend.append("text");
	responsesLegendLabel.attr("x", parseFloat(responsesLegendPoint.attr("cx")) + legendIconSize / 2 + graph.separation);
	responsesLegendLabel.attr("y", parseFloat(responsesLegendPoint.attr("cy")));
	responsesLegendLabel.attr("dy", "0.32em");
	responsesLegendLabel.text("Responses per minute");


	var errorsLegendPoint = legend.append("circle");
	errorsLegendPoint.attr("cx", responsesLegendPoint.attr("cx"));
	errorsLegendPoint.attr("cy", parseFloat(responsesLegendPoint.attr("cy")) + graph.separation + legendIconSize);
	errorsLegendPoint.attr("r", responsesLegendPoint.attr("r"));
	errorsLegendPoint.attr("class", "error point legend");

	var errorsLegendLineY = parseFloat(errorsLegendPoint.attr("cy"));
	var errorsLegendLineData =
	[
		{"x": 0,				"y": errorsLegendLineY},
		{"x": legendIconSize,	"y": errorsLegendLineY}
	];

	var errorsLegendLine = legend.append("path");
	errorsLegendLine.datum(errorsLegendLineData);
	errorsLegendLine.attr("d", unscaledLine);
	errorsLegendLine.attr("class", "error line legend");

	var errorsLegendLabel = legend.append("text");
	errorsLegendLabel.attr("x", parseFloat(errorsLegendPoint.attr("cx")) + legendIconSize / 2 + graph.separation);
	errorsLegendLabel.attr("y", parseFloat(errorsLegendPoint.attr("cy")));
	errorsLegendLabel.attr("dy", responsesLegendLabel.attr("dy"));
	errorsLegendLabel.text("Number of errors");


	var sundayLegendLineX = legendIconSize / 2;
	var sundayLegendLineY = parseFloat(errorsLegendPoint.attr("cy")) + legendIconSize / 2 + graph.separation;
	var sundayLegendLineData =
	[
		{"x": sundayLegendLineX,	"y": sundayLegendLineY},
		{"x": sundayLegendLineX,	"y": sundayLegendLineY + legendIconSize}
	];

	var sundayLegendLine = legend.append("path");
	sundayLegendLine.datum(sundayLegendLineData);
	sundayLegendLine.attr("d", roundedUnscaledLine);
	sundayLegendLine.attr("class", "sunday line dashed legend");

	var sundayLegendLabel = legend.append("text");
	sundayLegendLabel.attr("x", sundayLegendLineData[0]["x"] + legendIconSize / 2 + graph.separation);
	sundayLegendLabel.attr("y", sundayLegendLineData[0]["y"] + legendIconSize / 2);
	sundayLegendLabel.attr("dy", responsesLegendLabel.attr("dy"));
	sundayLegendLabel.text("Week division");


	if (showGoals === true)
	{
		var goalLegendLineX = sundayLegendLineX;
		var goalLegendLineY = sundayLegendLineData[1]["y"] + graph.separation;
		var goalLegendLineData =
		[
			{"x": goalLegendLineX,	"y": goalLegendLineY},
			{"x": goalLegendLineX,	"y": goalLegendLineY + legendIconSize}
		];

		var goalLegendLine = legend.append("path");
		goalLegendLine.datum(goalLegendLineData);
		goalLegendLine.attr("d", unscaledLine);
		goalLegendLine.attr("class", "goal line legend");

		var goalLegendLabel = legend.append("text");
		goalLegendLabel.attr("x", goalLegendLineData[0]["x"] + legendIconSize / 2 + graph.separation);
		goalLegendLabel.attr("y", goalLegendLineData[0]["y"] + legendIconSize / 2);
		goalLegendLabel.attr("dy", responsesLegendLabel.attr("dy"));
		goalLegendLabel.text("Exercise completed");
	}


	graph.updateChart();
	window.addEventListener("resize", graph.updateChart);
	graph.animate = true;
}

graph.removeSizeListener = () => {
	window.removeEventListener("resize", graph.updateChart)
}

graph.createPrintableCharts = function()
{
	/*
	*	Set up printable graphs
	*/
	var svg = document.querySelector("#progress-chart > svg");
	var printableDiv = document.getElementById("printable-charts");
	var svgContainer = d3.select("#progress-chart");
	var rightArrowMain = document.getElementById("right-arrow");

	var printChartWidth = 650;
	var labelSize = 160;

	svgContainer.style("width", printChartWidth + "px");
	graph.animate = false;
	graph.updateChart();

	var moveRight = 0;
	while(rightArrowMain.getAttribute("opacity") == "1")
	{
		graph.shiftChartRight();
		moveRight++;
	}
	var moreCharts = true;
	var totalPages = 0;

	while(moreCharts)
	{
		if (svg.querySelector("#chart").querySelectorAll("circle.response:not([opacity='0'])").length != 0 || totalPages == 0)
		{
			var svgCopy = svg.cloneNode(true);
			printableDiv.appendChild(svgCopy);

			var legend = svgCopy.querySelector("#legend");
			//.remove method doesn't work on SVG elements in IE, so this is a work around
			legend.parentNode.removeChild(legend);

			var leftArrow = svgCopy.querySelector("#left-arrow");
			var rightArrow = svgCopy.querySelector("#right-arrow");

			leftArrow.parentNode.removeChild(leftArrow);
			rightArrow.parentNode.removeChild(rightArrow);

			var height = parseFloat(svgCopy.getAttribute("height"));
			svgCopy.setAttribute("height", (height - labelSize) + "px");
		}

		if (svg.querySelector("#left-arrow").getAttribute("opacity") == "1")
			graph.shiftChartLeft();

		else
			moreCharts = false;

		//shift it twice if possible to remove graph repeats
		if (rightArrowMain.getAttribute("opacity") == "1")
		{
			graph.shiftChartLeft();
		}

		if (totalPages >= 30)
			break; //worst case to prevent infinite loop

		totalPages++;
	}

	while(rightArrowMain.getAttribute("opacity") == "1" && (totalPages - moveRight) > 0)
	{
		graph.shiftChartRight();
		totalPages--;
	}

	svgContainer.style("width", "");
	graph.updateChart();
	graph.animate = true;
}


graph.filterInactivePaths = function(data)
{
	return graph.filterInactivePoints(data[0]);
}

graph.filterInactivePoints = function(data)
{
	var currentTime = data["date"].getTime();

	return currentTime < graph.currentStartTime || currentTime > graph.currentEndTime;
}

graph.shiftChartLeft = function()
{
	if (graph.currentStartTime <= graph.startTime)
		return;

	graph.currentStartDate.setTime(graph.currentStartTime - graph.daysPerGroup * graph.millisecondsPerDay);
	graph.currentStartTime = graph.currentStartDate.getTime();

	graph.currentEndDate.setTime(graph.currentStartTime + (graph.daysPerGraph - 1) * graph.millisecondsPerDay);
	graph.currentEndTime = graph.currentEndDate.getTime();

	graph.updateChart();
}

graph.shiftChartRight = function()
{
	if (graph.currentEndTime >= graph.endTime)
		return;

	graph.currentStartDate.setTime(graph.currentStartTime + graph.daysPerGroup * graph.millisecondsPerDay);
	graph.currentStartTime = graph.currentStartDate.getTime();

	graph.currentEndDate.setTime(graph.currentStartTime + (graph.daysPerGraph - 1) * graph.millisecondsPerDay);
	graph.currentEndTime = graph.currentEndDate.getTime();

	graph.updateChart();
}

graph.drawReferenceLines = function(chart, startDate, endDate)
{
	var yLines = [5, 50, 100];


	for (var index = 0; index < yLines.length; index++)
	{
		var lineDatum =
		[
			{"date": startDate, "y": yLines[index]},
			{"date": endDate, "y": yLines[index]}
		];
		var path = chart.append("path");
		path.datum(lineDatum);
		path.attr("class", "light line");
	}
}

graph.updateChart = function()
{
	var svgContainer = d3.select("#progress-chart");
	var transition;

	if (graph.animate == true)
		transition = svgContainer.transition("resize");

	else
		transition = svgContainer;


	var margin = graph.margin;


	var width = svgContainer.node().offsetWidth;


	width -= margin.left + margin.right;
	var height = width / graph.aspectRatio;

	var svg = transition.select("svg");
	svg.attr("width", String(width + margin.left + margin.right) + "px");
	svg.attr("height", String(height + margin.top + margin.bottom) + "px");


	var chart = transition.select("#chart");
	
	graph.xScale.domain([graph.currentStartDate, graph.currentEndDate]);
	graph.xScale.range([0, width]);

	var xAxisTicks = [];
	var xAxisTickSeparation = 50 + 2 * graph.separation;
	var xAxisTickInterval = 7;

	if ((graph.xScale(new Date(graph.currentStartTime + 14 * graph.millisecondsPerDay)) - graph.xScale.range()[0]) < xAxisTickSeparation)
	{
		xAxisTickInterval = 21;
	}

	else if ((graph.xScale(new Date(graph.currentStartTime + 7 * graph.millisecondsPerDay)) - graph.xScale.range()[0]) < xAxisTickSeparation)
	{
		xAxisTickInterval = 14;
	}


	var currentMonday = new Date(graph.currentStartTime);
	while (currentMonday.getTime() <= graph.currentEndTime)
	{
		var currentMondayCopy = new Date(currentMonday.getTime());
		xAxisTicks.push(currentMondayCopy);

		currentMonday.setTime(currentMonday.getTime() + xAxisTickInterval * graph.millisecondsPerDay);
	}

	graph.xAxis.tickValues(xAxisTicks);

	xAxisGraphics = chart.select(".x.axis");
	xAxisGraphics.attr("transform", "translate(0, " + String(height + graph.separation) + ")");
	xAxisGraphics.call(graph.xAxis);


	graph.yScale.range([height, 0]);

	var yAxisTickSeparation = 1.5 * parseFloat(svgContainer.style("line-height"));

	var yAxisTicks = [1, 2, 5, 10, 20, 50, 100, 200];

	if ((graph.yScale(1) - graph.yScale(2)) < yAxisTickSeparation)
	{
		var length = yAxisTicks.length;
		for (var index = 1; index < length; index += 2)
		{
			yAxisTicks.splice(index, 1);
		}

		if ((graph.yScale(2) - graph.yScale(5)) < yAxisTickSeparation)
		{
			var length = yAxisTicks.length;
			for (var index = 2; index < length; index++)
			{
				yAxisTicks.splice(index, 1);
			}
		}
	}


	graph.yAxis.tickValues(yAxisTicks);
	yAxisGraphics = chart.select(".y.axis");
	yAxisGraphics.call(graph.yAxis);


	var responsePaths = chart.selectAll(".line.response");
	responsePaths.attr("d", graph.responsesLine);

	var errorPaths = chart.selectAll(".line.error");
	errorPaths.attr("d", graph.errorsLine);

	var otherPaths = chart.selectAll(".line:not(.response):not(.error)");
	otherPaths.attr("d", graph.dateLine);

	const currentWeekXOffset = 0;
	const currentWeekYOffset = 10;
	d3.select("#chart-area rect")
	.attr("width", width)
	.attr("height", height + currentWeekYOffset)

	chart.selectAll(".current-week-rect")
	.attr('x', (data) => { return graph.xScale(data[0].date) - currentWeekXOffset })
	.attr('width', (data) => { return (graph.xScale(data[1].date) - graph.xScale(data[0].date)) + currentWeekXOffset })
	.attr('height', height + currentWeekYOffset);


	var paths = chart.selectAll(".line");
	paths.attr("opacity", "1");

	var inactivePaths = paths.filter(graph.filterInactivePaths);
	inactivePaths.attr("opacity", "0");


	var points = chart.selectAll(".point:not(.clicker)");
	points.attr("opacity", "1");

	var responsePoints = chart.selectAll(".point.response");
	responsePoints.attr("cx", graph.responsesLine.x());
	responsePoints.attr("cy", graph.responsesLine.y());

	var errorPoints = chart.selectAll(".point.error");
	errorPoints.attr("cx", graph.errorsLine.x());
	errorPoints.attr("cy", graph.errorsLine.y());

	if (width <= 500)
	{
		var newPointSize = graph.pointSize + (1.5 - graph.pointSize) / 250 * (500 - width);
		if (newPointSize < 1.5)
		{
			newPointSize = 1.5;
		}

		points.attr("r", newPointSize);
	}

	else
	{
		points.attr("r", graph.pointSize);
	}


	var inactivePoints = points.filter(graph.filterInactivePoints);
	inactivePoints.attr("opacity", "0");


	var arrowY = height + xAxisGraphics.node().getBBox().height + graph.separation;
	controlButtons = transition.select("#control-buttons");
	controlButtons.attr("transform", "translate(0, " + (arrowY + graph.arrowHeight / 2) + ")");


	var leftArrow = transition.select("#left-arrow");
	leftArrow.attr("opacity", "1");

	var leftArrowNode = leftArrow.node();
	leftArrowNode.addEventListener("click", graph.shiftChartLeft);

	if (graph.currentStartTime <= graph.startTime)
	{
		leftArrow.attr("opacity", "0");

		leftArrowNode.removeEventListener("click", graph.shiftChartLeft);
	}

	var rightArrow = transition.select("#right-arrow");
	rightArrow.attr("transform", "translate(" + width + ", 0) scale(-1, 1)");
	rightArrow.attr("opacity", "1");

	var rightArrowNode = rightArrow.node();
	rightArrowNode.addEventListener("click", graph.shiftChartRight);

	if (graph.currentEndTime >= graph.endTime)
	{
		rightArrow.attr("opacity", "0");
		rightArrowNode.removeEventListener("click", graph.shiftChartRight);
	}


	var legend = transition.select("#legend");
	var legendCurrentWidth = legend.node().getBBox().width;
	var legendAllowedWidth = width - 2 * (graph.rectangleWidth + graph.separation * 2);
	var legendScale = 1;
	if (legendCurrentWidth > legendAllowedWidth)
	{
		legendScale = legendAllowedWidth / legendCurrentWidth;
		legendCurrentWidth = legendAllowedWidth;
	}

	legend.attr("transform", "translate(" + (width / 2 - legendCurrentWidth / 2) + ", " + arrowY + ") scale(" + legendScale + ")");
}


export default graph
